import { create } from "zustand";
import api from "../services/api";

const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount: 0,

  fetchNotifications: async () => {
    try {
      const { data } = await api.get("/notifications");
      set({ notifications: data });
    } catch (err) { console.error("Failed to fetch notifications:", err); }
  },

  fetchUnreadCount: async () => {
    try {
      const { data } = await api.get("/notifications/unread-count");
      set({ unreadCount: data.count });
    } catch (err) { console.error("Failed to fetch unread count:", err); }
  },

  markAllRead: async () => {
    try {
      await api.put("/notifications/read");
      set((s) => ({
        unreadCount: 0,
        notifications: s.notifications.map((n) => ({ ...n, read: true })),
      }));
    } catch (err) { console.error("Failed to mark notifications read:", err); }
  },

  addNotification: (notif) => {
    set((s) => ({
      notifications: [{ ...notif, read: false, created_at: new Date().toISOString() }, ...s.notifications],
      unreadCount: s.unreadCount + 1,
    }));
  },
}));

export default useNotificationStore;
